import gql from "graphql-tag";

export const BENEFICIARY_FRAGMENT = gql`
  fragment BeneficiaryInfo on Beneficiary {
    accountNumber
    accountType
    active
    beneficiaryType
    bicOrSwift
    display
    friendlyName
    iban
    id
    linkcyCardId
    linkcyId
    linkcyLedgerId
    name
    nameOnCard
    sortCode
    status
    truncatedPan
    type
  }
`;
